import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-36c81be0"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["disabled"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bi bi-linkedin" }, null, -1))

import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';


export default /*#__PURE__*/_defineComponent({
  props: {
    url: null,
    disabled: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
    url: string;
    disabled?: boolean;
}

const { t } = useI18n();
const store = useStore();
const currentLanguage = computed(() => store.getters.getCurrentLanguage || localStorage.getItem('currentLanguage'));



const share = () => {
  const linkedinUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${props.url}`;
  window.open(linkedinUrl, "_blank");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    onClick: share,
    type: "button",
    class: "btn btn-custom-achievement",
    disabled: props.disabled
  }, [
    _hoisted_2,
    _createTextVNode(" " + _toDisplayString(_unref(t)(`${_unref(currentLanguage)}.common.share_on_linkedin`)), 1)
  ], 8, _hoisted_1))
}
}

})